import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import { attendancePages } from "./web/attendance";
import { webOaPages } from "./web/oa";

import {systemPages} from "./web/system";

const viewport = {
  content: "width=device-width, initial-scale=1.0, user-scalable=no",
};

const router = new Router({
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "/index",
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),
      meta: { title: "登录", viewport: viewport },
    },
    {
      path: "/index",
      name: "index",
      component: () => import("@/views/Index.vue"),
      meta: { title: "", viewport: viewport },
    },
    {
      // 跨系统免登落地页：由焱火后台管理系统「OA办公」入口携带签名票据跳入
      path: "/ssoLogin",
      name: "ssoLogin",
      component: () => import("@/views/SsoLogin.vue"),
      meta: { title: "进入OA系统", viewport: viewport },
    },
    /**
     * 考勤打卡----路由配置
     */
    attendancePages(),
    /**
     * 审批管理----路由配置
     */
    webOaPages(),
    /**
     * 系统管理----路由配置
     */
    systemPages(),
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.content) {
    const head = document.getElementByTagName("head");
    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1.0, user-scalable=no";
    head[0].appendChild(meta);
  }
  localStorage.setItem("router-path", to.path);
  let urlData = getUrlData();
  if (to.path == '/miniLogin' && urlData!=null && urlData.type && urlData.type == "mini"){
      next();return;
  }else if (to.path == '/ssoLogin'){
      // 跨系统免登落地页：此时尚无登录态，必须放行，由页面自身完成换票
      next();return;
  }else {
    let  user = JSON.parse(localStorage.getItem("user"));
    if ((user == null || user.token == null) && to.path != '/login') {
      next({ name: 'login' });return;
    }
  }
  next();

});
  /**
   * 解析url中的参数值
   */
  function getUrlData(){
    let url = window.location.href;
    if (url==null || url == ""){
      return null;
    }
    let data = url.slice(url.indexOf('?') + 1);
    let pairs = data.split('&');
    let params = {};
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=');
      let key = decodeURIComponent(pair[0]);
      let value = decodeURIComponent(pair[1]);
      params[key] = value;
    }
    return params;
  }
export default router;
